import axios from 'axios';
import { createAction } from '@reduxjs/toolkit';
import NotificationService from '../services/NotificationService';
import * as UIActionTypes from '../constants/UIActionTypes';

const setError = createAction(UIActionTypes.setError);

export function createAssignmentMember(payload, notify) {
  return dispatch =>
    axios.post('/assignment/assignMember', payload)
      .then((response) => {
        if (notify) {
          NotificationService('updateAssignment', response);
        }
      })
      .catch((err) => {
        console.error(err.response || err); // eslint-disable-line no-console

        dispatch(setError(err.response || err));

        if (notify) {
          NotificationService('updateAssignment', err.response);
        }
      });
}

export function createAssignmentGroup(payload, notify) {
  return dispatch =>
    axios.post('/assignment/assignGroup', payload)
      .then((response) => {
        if (notify) {
          NotificationService('updateAssignment', response);
        }
      })
      .catch((err) => {
        console.error(err.response || err); // eslint-disable-line no-console

        dispatch(setError(err.response || err));

        if (notify) {
          NotificationService('updateAssignment', err.response);
        }
      });
}

export function createAssignmentSelf(payload, notify) {
  return dispatch =>
    axios.post('/assignment/assignSelf', payload)
      .then((response) => {
        if (notify) {
          NotificationService('updateAssignment', response);
        }
      })
      .catch((err) => {
        console.error(err.response || err); // eslint-disable-line no-console

        dispatch(setError(err.response || err));

        if (notify) {
          NotificationService('updateAssignment', err.response);
        }
      });
}

export function closeAssignment(payload) {
  const route = payload.assigned ? 'closeAssigned' : 'closeDefault';
  return dispatch =>
    axios.post(`/assignment/${route}`, payload)
      .then((response) => {
        NotificationService(payload.conversationActionType, response);
      })
      .catch((err) => {
        console.error(err.response || err); // eslint-disable-line no-console

        dispatch(setError(err.response || err));

        NotificationService('updateAssignment', err.response);
      });
}
